import { API, retryRequest } from 'src/services'
import { freezeItems } from './freezeItems'

const defaultOnly = [
  'name', 'id', 'kind', 'description'
]

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false
  },
  getters: {
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    resetItems (state) {
      state.items = []
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems ({ commit }, payload) {
      payload = payload || {}

      commit('loading', true)

      const { withFields = [], fullReload } = payload

      if (fullReload) {
        commit('resetItems')
      }

      const only = Array.from(new Set([...defaultOnly, ...withFields]))

      const result = await retryRequest(API.roleGroup.get, {
        fields: JSON.stringify(only),
        order_by: 'name'
      })
      commit('saveItems', result.body.success)
    }
  }
}
